import { Camera, CameraResultType } from '@capacitor/camera';
import { IonButton, IonCard, IonCardContent, IonCol, IonGrid, IonIcon, IonImg, IonInput, IonItem, IonLabel, IonNote, IonRow, IonSpinner, IonThumbnail, useIonAlert, useIonToast } from '@ionic/react';
import { addCircleOutline, personCircleOutline, refreshOutline, trashOutline } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import { useAppContext } from '../AppProvider';

interface AccountContactProps {
   getMember: (e: any) => void;
}

const AccountPhotos: React.FC<AccountContactProps> = ({ getMember }) => {   
    const [showToast] = useIonToast();
    const [showAlert] = useIonAlert();
    const [uploading_1, setUploading_1] = useState<boolean>(false);
    const [uploading_2, setUploading_2] = useState<boolean>(false);
    const [memberPhoto1, setMemberPhoto1] = useState<string>('');
    const [memberPhoto2, setMemberPhoto2] = useState<string>('');
    const memberPhotoPath = '//api.besolowise.com/members/photos/files/';   

    const { authKey, authorizedMember } = useAppContext();   
    

    useEffect(() => {
        //console.log(authorizedMember);
        const date = new Date();
        const time = date.getTime();
        setMemberPhoto1(authorizedMember.memberPhoto1ThumbnailUrl);
        setMemberPhoto2(authorizedMember.memberPhoto2ThumbnailUrl);
        //setMemberPhoto1(memberPhotoPath + 'tn-' + `${authorizedMember.memberPhoto1}` + 'v=' + time);
        //setMemberPhoto2(memberPhotoPath + 'tn-' + `${authorizedMember.memberPhoto2}` + '?v=' + time);
    }, [authorizedMember]);

    const takePhoto = async (e: any) => {
        const target = e.target;
        const photoNum = (target.id == 'addPhoto1' || target.id == 'addPhotoIcon1') ? '1' : '2'; 
        try {
            const photo = await Camera.getPhoto({
                quality: 99,
                allowEditing: false,
                resultType: CameraResultType.Base64,
            });
            const img = `data:image/jpeg;base64,${photo.base64String}`;
            updateMemberPhoto(img, photoNum);
        } catch (error) {
           console.log('Photo cancelled');
        }
    };

    const updateMemberPhoto = async (imageData: string, photoNum: string) => {
        photoNum == '1' ? setUploading_1(true) : setUploading_2(true);

        const btn: any = document.getElementById('addPhoto'+photoNum);
        btn.setAttribute('disabled', '');
        
        const formName = 'photo' + photoNum + 'Form';
        const formData = new FormData();
        const blob = await (await fetch(imageData)).blob();
        formData.append('formName', formName);
        formData.append('memberPhoto'+photoNum, blob, 'temp-image.jpg');
        formData.append('mt', authKey.mt);
    
        try {
            const response = await fetch('https://api.besolowise.com/members/update/', {
                method: 'POST',
                body: formData,
                credentials: 'include',
            });
          
            if(response.ok) {
                const obj = await response.json();
                
                if(obj.success) {
                    getMember(obj.mt);             
                    
                    showToast({
                        message: 'Your photo was updated',
                        duration: 2000,
                        color: 'success',
                    });
                } else {
                    photoNum == '1' ? setUploading_1(false) : setUploading_2(false);
                    showToast({
                        message: 'Error: Image upload failed.',
                        duration: 2000,
                        color: 'danger',
                    });
                }
            } else {
                showToast({
                    message: 'Error: Could not connect to server.',
                    duration: 2000,
                    color: 'danger',
                });
            }
        } catch (error) {
          showToast({
            message: 'Error: ' + error,
            duration: 2000,
            color: 'danger',
          });
        }
        photoNum == '1' ? setUploading_1(false) : setUploading_2(false);
    };

    const rotatePhoto = async (e: any) => {
        const target = e.target;
        const photoNum = target.id == 'rotatePhoto1' ? '1' : '2'; 
        const btn: any = document.getElementById(target.id);
        btn.setAttribute('disabled', '');
        const file = photoNum == '1' ? `${authorizedMember.memberPhoto1}` : `${authorizedMember.memberPhoto2}`;
        const formData = new FormData();
        formData.append('file', file);   
        formData.append('mt', authorizedMember.memberToken);           
        try {
            const response = await fetch('https://api.besolowise.com/members/photos/rotate/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });

            if(response.ok) {
                const obj = await response.json(); 
                btn.removeAttribute('disabled');
                if(obj.success) getMember(obj.mt);
                else {
                    showToast({
                        message: 'Error: Photo was not rotated.',
                        duration: 2000,
                        color: 'danger',
                    });
                }

            } else {
                btn.removeAttribute('disabled');
                showToast({
                    message: 'Error: Could not connect to server.',
                    duration: 2000,
                    color: 'danger',
                });
            }
        } catch (error) {
            btn.removeAttribute('disabled');
            showToast({
              message: 'Error: Image rotation failed.',
              duration: 2000,
              color: 'danger',
            });
        }
        
    };

    const deletePhoto = async (e: any) => {        
        const target = e.target;
        const photoNum = target.id == 'deletePhoto1' ? '1' : '2'; 
        const field = 'memberPhoto' + photoNum;
        const file = photoNum == '1' ? `${authorizedMember.memberPhoto1}` : `${authorizedMember.memberPhoto2}`;
        showAlert({
            header: 'Confirm!',
            message: 'Are you sure you want to DELETE this photo?',
            buttons: [
                {
                    text: 'Cancel', 
                    role: 'cancel', 
                    cssClass: 'alert-button-cancel',
                },
                {
                    text: 'Delete',
                    cssClass: 'alert-button-confirm',
                    handler: async () => {
                        const formData = new FormData();
                        formData.append('field', field);
                        formData.append('file', file);
                        formData.append('mt', authorizedMember.memberToken); 
                        try {
                            const response = await fetch('https://api.besolowise.com/members/photos/delete/', {
                                method: 'POST',
                                credentials: 'include',
                                body: formData
                            });

                            if(response.ok) {
                                const obj = await response.json(); 
                                if(obj.success) {
                                    getMember(obj.mt);
                                    showToast({
                                        message: 'Success! Photo was deleted.',
                                        duration: 2000,
                                        color: 'success',
                                    });
                                } else {
                                    showToast({
                                        message: 'Data Error: Photo was not deleted. Try again.',
                                        duration: 2000,
                                        color: 'danger',
                                    });
                                }
                            } else {
                                showToast({
                                    message: 'Response Error: Photo was not deleted. Try again.',
                                    duration: 3000,
                                    color: 'danger',
                                    position: 'middle'
                                });
                            }
                        } catch (error) {
                            showToast({
                                message: 'Connection Error: Photo was not deleted. ' + error + ' Try again.',
                                duration: 3000,
                                color: 'danger',
                            });
                        }
                    }
                }
            ]
        })        
    };

    return (
        <>
            <IonItem slot='header'>
                <IonLabel>My Photos</IonLabel>
            </IonItem>
            <div className='ion-padding' slot='content'>
                <IonGrid fixed>
                    <IonRow class='ion-justify-content-center'>
                        <IonCol size='12' sizeSm='6'>
                            <IonCard className='ion-text-center'>
                                <IonCardContent>
                                    <IonLabel color={'dark'}><b>Primary Photo</b></IonLabel><br /> 
                                    <IonNote>Photos must be in .jpg format.</IonNote>
                                    <IonThumbnail>
                                        {uploading_1
                                            ? (<div className='no-user-photo'><IonSpinner name="crescent"></IonSpinner></div>)
                                            : (authorizedMember.memberPhoto1 == ''
                                                ? (<div className='no-user-photo' id='addPhotoIcon1'><IonIcon icon={personCircleOutline}></IonIcon></div>)  
                                                : (<IonImg src={memberPhoto1} />)
                                            )
                                        } 
                                    </IonThumbnail>
                                    {authorizedMember.memberPhoto1 == ''
                                        ? (<IonButton expand='block' color={'secondary'} onClick={takePhoto} id='addPhoto1'><IonIcon slot="start" icon={addCircleOutline}></IonIcon> Add Photo</IonButton>)
                                        : (<>
                                            <IonButton className='ion-margin-bottom' color={'secondary'} expand='block' fill='outline' onClick={rotatePhoto} id='rotatePhoto1'><IonIcon slot="start" icon={refreshOutline}></IonIcon> Rotate</IonButton>
                                            <IonButton color={'danger'} expand='block' fill='outline' onClick={deletePhoto} id='deletePhoto1'><IonIcon slot="start" icon={trashOutline}></IonIcon> Delete</IonButton>
                                           </>) 
                                    }  
                                </IonCardContent>
                            </IonCard>
                        </IonCol>
                        <IonCol size='12' sizeSm='6'>                            
                            <IonCard className='ion-text-center'>
                                <IonCardContent>
                                    <IonLabel color={'dark'}><b>Secondary Photo</b></IonLabel> <br /> 
                                    <IonNote>Photos must be in .jpg format.</IonNote> 
                                    <IonThumbnail>
                                        {uploading_2
                                            ? (<div className='no-user-photo'><IonSpinner name="crescent"></IonSpinner></div>)
                                            : (authorizedMember.memberPhoto2 == ''
                                                ? (<div className='no-user-photo' id='addPhotoIcon2'><IonIcon icon={personCircleOutline}></IonIcon></div>)  
                                                : (<IonImg src={memberPhoto2} />)
                                            )
                                        } 
                                    </IonThumbnail>
                                    {authorizedMember.memberPhoto2 == ''
                                        ? (<IonButton color={'secondary'} expand='block' onClick={takePhoto} id='addPhoto2'><IonIcon slot="start" icon={addCircleOutline}></IonIcon> Add Photo</IonButton>)
                                        : (<>
                                            <IonButton className='ion-margin-bottom' color={'secondary'} expand='block' fill='outline' onClick={rotatePhoto} id='rotatePhoto2'><IonIcon slot="start" icon={refreshOutline}></IonIcon> Rotate</IonButton>
                                            <IonButton color={'danger'} expand='block' fill='outline' onClick={deletePhoto} id='deletePhoto2'><IonIcon slot="start" icon={trashOutline}></IonIcon> Delete</IonButton>
                                           </>) 
                                    }  
                                </IonCardContent>
                            </IonCard>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </div>
        </>
    );
};

export default AccountPhotos;